<template>
  <div class="row">
    <div class="column column-100 header">
      {{ labels['title'] }}
      <a href="https://ovdinfo.org" target="_blank">
        <img :src="require('@/assets/logo.png')">
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    lang: state => state.language,
    labels: state => LABELS[state.language]
  })
}
</script>

<style>
  .oi-donation-form .header {
    display: flex;
    justify-content: space-around;
    font-size: 20px;
  }
  .oi-donation-form .header img {
    height: 30px;
  }
</style>
